/**
 * Share, using whatever the device actually has.
 *
 * navigator.share opens the OS sheet — every app the person already uses, no
 * list for us to curate or keep current. Where it does not exist (most
 * desktops) the link goes to the clipboard instead, which is what someone
 * reaches for next anyway.
 */
class ShareButtons extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-share-native]');
    this.copied = this.querySelector('[data-share-copied]');
    if (!this.button) return;

    this.onShare = this.onShare.bind(this);
    this.button.addEventListener('click', this.onShare);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.onShare);
    clearTimeout(this.timer);
  }

  async onShare() {
    const url = this.dataset.url;
    const title = this.dataset.title;

    if (navigator.share) {
      // A cancelled share rejects. That is a decision, not a failure.
      try {
        await navigator.share({ title, url });
      } catch (error) {
        if (error.name !== 'AbortError') this.copy(url);
      }
      return;
    }

    this.copy(url);
  }

  async copy(url) {
    try {
      await navigator.clipboard.writeText(url);
      this.flash();
    } catch {
      // Clipboard needs a secure context and permission. Nothing to fall back
      // to, and a broken-looking button is worse than one that quietly stops.
    }
  }

  flash() {
    if (!this.copied) return;
    this.copied.hidden = false;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.copied.hidden = true;
    }, 2000);
  }
}

customElements.define('share-buttons', ShareButtons);
